import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: "The results exceeded my expectations! The team is incredibly professional and made me feel comfortable throughout the entire process. My skin has never looked better.",
      name: "Sarah Mitchell",
      image: "https://public.readdy.ai/ai/img_res/d8f0ec0d5255829597b2f665e98882df.jpg",
      platform: "Google Reviews"
    },
    {
      text: "I've been coming here for over two years and wouldn't trust anyone else with my aesthetic treatments. The attention to detail and personalized care is unmatched.",
      name: "Jennifer Adams",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20sophisticated%20woman%20in%20her%2030s%20radiant%20skin%20warm%20smile%20elegant%20appearance%20clean%20background%20natural%20lighting&width=500&height=500&seq=test002&orientation=squarish",
      platform: "Google Reviews"
    },
    {
      text: "From consultation to follow-up, the entire experience was exceptional. The clinic is beautiful, the staff is knowledgeable, and my results are exactly what I wanted.",
      name: "Emily Rodriguez",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20beautiful%20woman%20in%20her%2050s%20youthful%20appearance%20confident%20expression%20flawless%20skin%20clean%20simple%20background&width=500&height=500&seq=test003&orientation=squarish",
      platform: "Google Reviews"
    },
    {
      text: "The best decision I made was choosing this clinic for my treatments. The doctors are true artists who understand facial aesthetics and deliver natural-looking results.",
      name: "Amanda Chen",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20asian%20woman%20in%20her%2030s%20glowing%20complexion%20gentle%20smile%20sophisticated%20look%20clean%20background&width=500&height=500&seq=test004&orientation=squarish",
      platform: "Google Reviews"
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-esthe-light-pink via-esthe-floral-white to-esthe-rose/30">
      <div className="max-w-6xl mx-auto px-8">
        <div className="relative">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative z-10">
              <div className="text-esthe-rose text-9xl font-serif leading-none mb-6">"</div>
              <p className="text-3xl font-serif italic text-esthe-cafe-noir leading-relaxed mb-8">
                {testimonials[currentIndex].text}
              </p>
              <div className="flex items-center gap-3 mb-2">
                <h4 className="text-lg font-bold text-esthe-cafe-noir">
                  {testimonials[currentIndex].name}
                </h4>
              </div>
              <div className="flex items-center gap-2 text-esthe-light-bronze">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-base"></i>
                </div>
                <span className="text-sm font-medium">{testimonials[currentIndex].platform}</span>
              </div>
            </div>

            <div className="relative">
              <div className="w-96 h-96 mx-auto">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-full h-full object-cover object-top rounded-3xl shadow-2xl"
                />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-esthe-pale-taupe text-esthe-mocha hover:border-esthe-light-bronze hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>

            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === currentIndex ? 'bg-esthe-light-bronze w-8' : 'bg-esthe-pale-taupe'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-esthe-pale-taupe text-esthe-mocha hover:border-esthe-light-bronze hover:text-esthe-light-bronze transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
